const dev = {
  API_ENDPOINT_URL: "http://localhost:8000/react_api",
};

const prod = {
  API_ENDPOINT_URL: "https://painel.lavcontrol.com.br/react_api",
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    default:
      break;
  }
};

export const env = getEnv();
